import React, { Component } from 'react';
import ValidatedCheckbox from '../ValidatedCheckbox/ValidatedCheckbox';

const Step9 = (props) => {
    return (
        <div>
            <h2>אישור כל ההצהרות</h2>
            <ValidatedCheckbox 
            name="finalConfirmation" 
            label="אני מאשר שהבנתי את ההצהרות שנתבקשתי לחתום עליהן וכי כל הפרטים שמסרתי נכונים ואני מאשר להמשיך ולבצע עבורי בדיקה לרמה 6 (שמור)" 
            validated={true} 
            tabIndex="1"/>
        </div>
    );
  };
  
  export default Step9;